import { listeningReadingQuestions } from './question_listen2.js';
import { studyGuideData } from './study_guide.js';

export const chapters = [
  // ── 来源：BJT商务日语能力测试+模拟与对策.pdf ──
  { id: 7, title: "第1部聴解", pages: "P1~P19" },
  { id: 8, title: "第2部聴読解", pages: "P20~P36" },
  { id: 9, title: "第3部読解", pages: "P37~P55" },
  // ── 来源：BJT商务日语能力考试分项精解与训练.pdf ──
  { id: 5, title: '如何刷题', pages: "P168~P233" },
  { id: 6, title: '练习模式', pages: "" },
];

export const sectionData = {
  ...studyGuideData,
  5: {
    chapterTitle: 'BJT模拟试卷三：从"盲目刷题"到"精准诊断"的战术手册',
    coreQuestion:
      '如何将一套完整的模拟试卷，从"盲目刷题"转化为系统性"精准诊断"的高效学习工具？',
    hasBjtSim: true,
    sections: [
      {
        id: "B1",
        title: "B1. 全真模拟与初步感知",
        intro: {
          overview: "章前总览：在正式进入精细化分析之前，首先需要在真实条件下完整体验一套模拟试卷，建立对自身能力现状的初步感知。",
          highlight: "严格按照考试规则完成全套模拟，不查字典、不暂停、不回看，记录真实作答状态。",
          logicChain: [],
        },
        subsections: [],
      },
      {
        id: "B2",
        title: "B2. 客观评分与错题定位",
        intro: {
          overview: "章前总览：完成模拟后，进行客观、系统的评分，精确定位每一道错题的位置和题型。",
          highlight: "建立错题清单，按题型（听解/听读解/读解）和题号分类记录，为后续分析提供原始数据。",
          logicChain: [],
        },
        subsections: [],
      },
      {
        id: "B3",
        title: "B3. 错题归因与能力短板诊断",
        intro: {
          overview: '章前总览：对每道错题追问"为什么错"，将错误归因为可改进的能力维度，形成个人能力短板诊断报告。',
          highlight: '错误归因不停留在"不会"，而是精确到：词汇量不足、语法点盲区、听力速度跟不上、还是逻辑推断失误。',
          logicChain: [],
        },
        subsections: [],
      },
      {
        id: "B4",
        title: "B4. 考点提炼与出题逻辑分析",
        intro: {
          overview: "章前总览：从错题和正确题中提炼高频考点，理解出题人的命题逻辑与设陷方式。",
          highlight: "掌握命题规律，预测考试重点，将碎片化题目经验转化为结构化考点知识体系。",
          logicChain: [],
        },
        subsections: [],
      },
      {
        id: "B5",
        title: "B5. 针对性复习策略制定",
        intro: {
          overview:
            '章前总览：在完成了全真模拟（B1）、客观评分（B2）、错题归因（B3）和考点分析（B4）之后，我们已经从一份试卷中提取出了关于自身商务日语能力的"诊断报告"。本章的核心任务是：如何将这份"诊断报告"转化为一份具体、可执行的"治疗与康复计划"，确保后续的复习能够精准打击薄弱环节，实现高效提分。',
          highlight: '如何将这份"诊断报告"转化为一份具体、可执行的"治疗与康复计划"',
          logicChain: [
            '确定优先级：基于B3的诊断结果，哪些能力模块（如"听解"、"读解"）或题型（如"听读解"、"表現力問題"）是当前最薄弱、提分空间最大的？ -> C14：薄弱能力模块优先级排序',
            '设计专项训练：针对高优先级的模块，具体应该做什么样的练习来弥补短板？ -> C15：针对"聴解"的专项精听与跟读计划 -> C16：针对"読解"的速读与长难句分析训练',
            '优化应试策略：除了知识本身，如何优化考试当天的答题策略，以最大化发挥现有水平？ -> C17：答题顺序与时间分配优化方案',
          ],
        },
        subsections: [],
      },
    ],
  },
  6: {
    chapterTitle: '练习模式',
    coreQuestion: '',
    hasPractice: true,
    defaultSectionId: 'p3_s1',
    sections: [
      {
        id: 'p1_s1', title: 'Section1-1：場面把握問題',
        group: '第一部分  听力',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
      {
        id: 'p1_s2', title: 'Section1-2：発言聴解問題',
        group: '第一部分  听力',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
      {
        id: 'p1_s3', title: 'Section1-3：総合聴解問題',
        group: '第一部分  听力',
        type: 'listening',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
      {
        id: 'p2_s1', title: 'Section2-1：状況把握問題',
        group: '第二部分  听力与阅读理解',
        type: 'listeningReading2',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: listeningReadingQuestions.slice(0, 20),
      },
      {
        id: 'p2_s2', title: 'Section2-2：資料聴読解問題',
        group: '第二部分  听力与阅读理解',
        type: 'listeningReading2',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: listeningReadingQuestions.slice(20, 40),
      },
      {
        id: 'p2_s3', title: 'Section2-3：総合聴読解問題',
        group: '第二部分  听力与阅读理解',
        type: 'listeningReading2',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: listeningReadingQuestions.slice(40, 60),
      },
      {
        id: 'p3_s1', title: 'Section3-1：語彙・文法問題',
        group: '第三部分  阅读理解',
        readingTypes: ['grammar', 'vocab', 'expression'],
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
      {
        id: 'p3_s2', title: 'Section3-2：表現読解問題',
        group: '第三部分  阅读理解',
        readingSource: 'expressionReading',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
      {
        id: 'p3_s3', title: 'Section3-3：総合読解問題',
        group: '第三部分  阅读理解',
        readingSource: 'comprehensiveReading',
        intro: { overview: '', highlight: '', logicChain: [] },
        subsections: [],
      },
    ],
  },
};
